export interface XmlAttribute {
	name: string;
	value: string;
}

export interface XmlElement {
	name: string;
	value?: string;
	attributes?: XmlAttribute[];
	children?: XmlElement[];
}

function createElement({ name, value, attributes, children }: XmlElement, namespace?: string): Element {

	const element = namespace ? document.createElementNS(namespace, name) : document.createElement(name);

	if (value)
		element.textContent = value;

	if (attributes)
		attributes.forEach(a => element.setAttribute(a.name, a.value));

	if (children)
		children.forEach(x => element.appendChild(createElement(x, namespace)));

	return element;
}

const Xml = {
	serialize(element: XmlElement, namespace?: string): string {
		// Para que sea case sensitive y no tenga en cuenta por defecto el namespace de xhmtl le ponemos un namespace
		// dummy y  luego lo borramos
		let xml = new XMLSerializer().serializeToString(createElement(element, namespace || 'dummy'));
		xml = xml.replace(' xmlns="dummy"', '');
		return xml;
	}
};

export { Xml };
